
import { useState, useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { Integration } from '@/types/integrations';
import { createIntegrationService } from './integrationService';

export const useIntegrations = () => {
  const [integrations, setIntegrations] = useState<Integration[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  console.log('🚀 useIntegrations: Hook inicializado');

  const service = createIntegrationService(setIntegrations, setIsLoading, toast);

  useEffect(() => {
    console.log('🔄 useIntegrations: Executando fetchIntegrations');
    service.fetchIntegrations().catch(error => {
      console.error('❌ useIntegrations: Erro ao buscar integrações', error);
    });
  }, []);

  console.log('📊 useIntegrations: Estado atual', {
    integrationsCount: integrations.length,
    isLoading,
    integrations: integrations.map(i => ({
      id: i.id,
      type: i.integration_type,
      status: i.status
    }))
  });

  return {
    integrations,
    isLoading,
    createIntegration: service.createIntegration,
    updateIntegration: service.updateIntegration,
    deleteIntegration: service.deleteIntegration,
    testConnection: service.testConnection,
    generateQRCode: service.generateQRCode,
    checkConnectionStatus: service.checkConnectionStatus,
    refetch: service.fetchIntegrations
  };
};
